import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    NullableBooleanInput,
    SelectInput,
    required,
    ReferenceInput,
    AutocompleteInput,
    useDataProvider,
    minValue,
    NumberInput,
} from 'react-admin';

import { Banners } from '../../custom';
import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import { BANNER_TYPE } from '../../common/constants';
import { useEffect, useState } from 'react';

const BannerEdit = () => {
    const { isUpdatable } = useIsPermission('BANNERS');
    const dataProvider = useDataProvider();
    const record = useRecordContext();
    const [bannerCategory, setBannerCategory] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        dataProvider
            .getList('banner-categories', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => {
                let updatedCategory = data;
                if (record?.categoryId && !data.some((s: any) => s.id === record.categoryId)) {
                    updatedCategory = [...data, { id: record.categoryId, name: 'Loading...' }];
                }
                setBannerCategory(updatedCategory);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching Banner Category:', error);
                setLoading(false);
            });
    }, [dataProvider, record?.categoryId]);

    const catgoryChoices = bannerCategory.map(s => ({ id: String(s.id), name: s.name }));

    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit mutationMode={'pessimistic'} title={<BannerTitle />}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload
                        type="VIDEO_THUMBNAIL"
                        source={'image'}
                        required={true}
                        accept={'image/*'}
                    />
                    <NumberInput source="displayOrder" fullWidth validate={[ required(), minValue(1)]} />
                    <NullableBooleanInput source="hidden" fullWidth label={'Hidden'}  />
                    <TextInput source="redirect_url" fullWidth validate={[required()]} />
                    <SelectInput
                        source="type"
                        label={'Type'}
                        fullWidth
                        validate={[required()]}
                        choices={BANNER_TYPE}
                    />

                    <AutocompleteInput
                        source="categoryId"
                        label="Category"
                        fullWidth
                        validate={[required()]}
                        choices={catgoryChoices}
                        optionText="name"
                        optionValue="id"
                        disabled={loading}
                    />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    );
};

const BannerTitle = () => {
    const record = useRecordContext<Banners>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.banners.name', { smart_count: 1 })} &quot;
            {record.id}&quot;
        </span>
    ) : null;
};

export default BannerEdit;
